import { BaseDataService, NotificationService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { BaseUpdateComponent, BaseContainerService } from 'yt-ng-framework';
import { PodVrstaDokumenta } from './podvrste-dokumenta';
//import { NotifierService } from 'angular-notifier';
// import { NotificationsService } from 'angular2-notifications';
import { Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-podvrste-dokumenta-update',
  templateUrl: './podvrste-dokumenta-update.component.html'
})
export class PodVrsteDokumentaUpdateComponent 
extends BaseUpdateComponent<PodVrstaDokumenta> 
implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc("VrstaDokumentaID", Validators.required, "required", "PODVRSTADOKUMENTA.VRSTADOKUMENTA.VALIDATION.REQUIRED");
    this.addValidatorToFc("Naziv", Validators.required, "required", "PODVRSTADOKUMENTA.NAZIV.VALIDATION.REQUIRED");
    this.addValidatorToFc("Naziv", Validators.maxLength(100), "maxlength", "PODVRSTADOKUMENTA.NAZIV.VALIDATION.REQUIRED");
    // this.addValidatorToFc("SNaziv", Validators.required, "required", "PODVRSTADOKUMENTA.SNAZIV.VALIDATION.REQUIRED");
    this.addValidatorToFc("SNaziv", Validators.maxLength(10), "maxlength", "PODVRSTADOKUMENTA.SNAZIV.VALIDATION.MAXLENGTH");
    this.addValidatorToFc("GenericName", Validators.required, "required", "PODVRSTADOKUMENTA.GENERICNAME.VALIDATION.REQUIRED");
    this.addValidatorToFc("GenericName", Validators.maxLength(10), "maxlength", "PODVRSTADOKUMENTA.GENERICNAME.VALIDATION.MAXLENGHT");
    this.addValidatorToFc("Model", Validators.maxLength(50), "maxlength", "PODVRSTADOKUMENTA.MODEL.VALIDATION.MAXLENGHT");
    this.addValidatorToFc("Opis", Validators.maxLength(200), "maxlenght", "PODVRSTADOKUMENTA.OZNAKA.VALIDATION.MAXLENGHT");
    this.addValidatorToFc("OdgovornoLiceJeObavezno", Validators.required, "required", "PODVRSTADOKUMENTA.ODGOVORNOLICEJEOBAVEZNO.VALIDATION.REQUIRED");

  }

}
